import React from 'react';
import { EditorPositionAlign, EditorPrebuiltModule } from '@dev/template-editor';
import { useTranslation } from 'react-i18next';
import { FeatureLeftAlignedImagePreview } from './preview';

export const useFeatureLeftAlignedImage = (): EditorPrebuiltModule => {
    const { t } = useTranslation();

    return {
        id: 'feature-left-aligned-image',
        title: t('featureleftalignedimage'),
        icon: <FeatureLeftAlignedImagePreview />,
        data: {
            name: 'editor/twocolumnsfiftyfiftyblock-v1',
            attributes: {},
            innerBlocks: [
                [
                    {
                        name: 'editor/imageblock-v1',
                        attributes: {},
                    },
                ],
                [
                    {
                        name: 'editor/headingblock-v1',
                        attributes: {
                            padding: { paddingLeft: 20, paddingBottom: 10, paddingRight: 20, paddingTop: 20 },
                            content: 'Heading',
                        },
                    },
                    {
                        name: 'editor/paragraphblock-v1',
                        attributes: {
                            content: 'This is the place for your content. Did you know that email marketing has...',
                        },
                    },
                    {
                        name: 'editor/buttonblock-v1',
                        attributes: {
                            position: EditorPositionAlign.LEFT,
                            content: 'Button',
                        },
                    },
                ],
            ],
        },
    };
};
